"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pathParametersToListingType = void 0;
var _node = require("@domain-group/fe-allhomes-library/lib/node");
var pathParametersToListingType = slug => {
  var _Object$values$find;
  if (slug === 'sold') {
    return 'SALES_RESIDENTIAL';
  }
  return ((_Object$values$find = Object.values(_node.ListingType).find(listingType => listingType.urlContext === slug)) === null || _Object$values$find === void 0 ? void 0 : _Object$values$find.name) || 'SALES_RESIDENTIAL';
};
exports.pathParametersToListingType = pathParametersToListingType;